function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("filter", {
  id: "glow",
  width: "150%",
  height: "150%"
}, /*#__PURE__*/React.createElement("feOffset", {
  result: "offOut",
  in: "SourceGraphic",
  dx: 0,
  dy: 0
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  result: "matrixOut",
  in: "offOut",
  type: "matrix",
  values: "0.2 0 0 0 0 0 0.2 0 0 0 0 0 0.2 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blurOut",
  in: "matrixOut",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "blurOut",
  mode: "normal"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "pathgroup"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "path",
  stroke: "rgba(227, 251, 255, 0.75)",
  fill: "#FFFFFF",
  points: "62.889,0 42.427,35.666 39.004,30 21.965,0 6.889,0 23.849,30 41.965,60 77.965,0  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "path",
  stroke: "rgba(227, 251, 255, 0.75)",
  fill: "#FFFFFF",
  points: "21.965,0 6.889,0 23.849,30.001 14.238,47 0,47 0,60 6.889,60 21.247,60 21.965,60 39.004,30  "
}));

var SvgLogo = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "104px",
    height: "80px",
    viewBox: "-13 -10 104 80",
    enableBackground: "new -13 -10 104 80",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.b556f805.svg";
export { ForwardRef as ReactComponent };